module.exports = __webpack_public_path__ + "img/businessModel1.d866bd92.png";